import { useEffect, useState } from "react"
import clienteAxios from "../../../configAxios/configAxios";


const useCategorias = () => {
    const [categorias, setCategorias] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchCategorias = async () => {
            try {
                let response = await clienteAxios.get('Categorias/modulo/MERC_PUBLICO');

                setLoading(false);
                if (response.status === 200) {
                    let data = response.data.data;
                    setCategorias(data);
                }
            } catch (error) {
                setLoading(false);
                setError(true)
            }
        }
        fetchCategorias();
    }, []);

    return [categorias, error, isLoading]
};

export const useListaPDF = () => {
    const [listaPDF, setListaPDF] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchListaPDF = async () => {
            try {
                let response = await clienteAxios.get('Parametro/activo/MERC_PUBLICO');

                setLoading(false);
                if (response.status === 200) {
                    let data = response.data.data;
                    data.filter(e => e.Etiqueta === 'PRECIOS');
                    setListaPDF(data);
                }
            } catch (error) {
                setLoading(false);
                setError(true)
            }
        }
        fetchListaPDF();
    }, []);

    return [listaPDF, error, isLoading]
};

export const useVehiculos = (id) => {
    const [vehiculos, setVehiculos] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        const fetchVehiculos = async (id) => {
            try {
                setLoading(true);
                let response = await clienteAxios.get(`mercadoPublicoPorCategoria/${id}`);

                setLoading(false)
                if (response.status === 200) {
                    let data = response.data.data;

                    setVehiculos(data)
                }
            } catch (error) {
                setLoading(false);
                setError(true)
            }
        };
        fetchVehiculos(id ? id : "0");


    }, [id]);

    return [vehiculos, error, isLoading, setVehiculos]
}

export const useVehiculoSlug = (slug) => {
    const [vehiculo, setVehiculo] = useState(undefined);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fecthVehiculo = async () => {
            try {
                let response = await clienteAxios.get(`MercadoPublico/fichaVehiculo/${slug}`);
                setLoading(false);
                if (response.status === 200) {
                    let data = response.data.data;
                    setVehiculo(data)
                    return;
                }

                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        if (slug) {
            fecthVehiculo();
        }
    }, [slug])

    return { vehiculo, isLoading, error }
}


export default useCategorias;